var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M396.38 286.28c-16.64 16.64-16.64 43.52 0 60.16l165.55 165.55-165.55 165.55c-16.64 16.64-16.64 43.52 0 60.16 16.64 16.64 43.52 16.64 60.16 0l195.84-195.84c16.64-16.64 16.64-43.52 0-60.16L456.54 285.86c-16.21-16.21-43.52-16.21-60.16.43Z"
  })));
};
export default SvgRight;